import { useTheme } from 'styled-components'
import { IconBase, IconProps } from './Base'

export const IconDots = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 14} height={props.height || 14} viewBox="0 0 14 14" fill="none">
      <g
        stroke={theme.colors.text.secondary}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        clipPath="url(#a)"
      >
        <path d="M7.001 7.583a.583.583 0 1 0 0-1.167.583.583 0 0 0 0 1.167ZM7.001 3.5a.583.583 0 1 0 0-1.167.583.583 0 0 0 0 1.167ZM7.001 11.667a.583.583 0 1 0 0-1.167.583.583 0 0 0 0 1.167Z" />
      </g>
    </IconBase>
  )
}
